import { Injectable } from '@angular/core';
import { FileDTO, FileListRequestParams } from '../../../../../common/dto/file.dto';
import { CoolHttp } from '@angular-cool/http';
import { ServerUrls } from '../../../../../common/dto/server-urls';

@Injectable()
export class FilesService {
  constructor(
    private _http: CoolHttp,
  ) {
  }

  public async getFilesAsync(params: FileListRequestParams): Promise<FileDTO[]> {
    return await this._http.getAsync(ServerUrls.Files._.Get.absoluteUrl, {
      params: {
        [ServerUrls.Files._.Get.queryParams.limit]: params.limit?.toString() ?? '',
        [ServerUrls.Files._.Get.queryParams.skip]: params.skip?.toString() ?? '',
        [ServerUrls.Files._.Get.queryParams.filter]: params.filter ?? '',
        [ServerUrls.Files._.Get.queryParams.type]: params.type ?? '',
      },
    });
  }

  public async uploadFileAsync(file: File): Promise<FileDTO> {
    const formData = new FormData();

    formData.append('file', <Blob><any>file);

    return await this._http.postAsync(ServerUrls.Files._.Upload.absoluteUrl, formData);
  }

  public readFileAsync(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener('error', e => {
        reject(e);
      });

      reader.addEventListener('load', () => {
        resolve(reader.result);
      });

      reader.readAsDataURL(file);
    });
  }
}
